import { PilotUserSignUpProps } from '@model/user/pilot-user-sign-up.model'
import {
  APP_NAME,
  emailDisplayString,
  emailPlaceholder,
  firstNameDisplayString,
  lastNameDisplayString,
  phoneDisplayString
} from '@shared/constants'
import { MatIconEnum } from '@view/shared/icon.view'

/** The welcome page can be configured to allow creation of account by the user, or interaction with a submission form, alternatively it's hidden. */
export enum WelcomePageFeature {
  createAccount = 'createAccount',
  signUp = 'signUp',
  disabled = 'disabled'
}
export const WelcomePageCtaBtnDisplayText: Record<WelcomePageFeature, string> = {
  createAccount: 'Create Account',
  signUp: 'Sign Up',
  /** When disable this cta button is hidden so no display text is needed unless the requirements change. */
  disabled: ''
}
export namespace PilotUserSignUpFormVm {
  export const LabelTextForUserProp: Record<PilotUserSignUpProps, string> = {
    [PilotUserSignUpProps.firstName]: firstNameDisplayString,
    [PilotUserSignUpProps.lastName]: lastNameDisplayString,
    [PilotUserSignUpProps.email]: emailDisplayString,
    [PilotUserSignUpProps.phone]: phoneDisplayString,
    [PilotUserSignUpProps.school]: 'School',
    [PilotUserSignUpProps.position]: 'Position',
    [PilotUserSignUpProps.city]: 'City',
    [PilotUserSignUpProps.state]: 'State',
    [PilotUserSignUpProps.information]: 'Tell us about your school'
  }
  export const PlaceholderTextByUserProp: Record<PilotUserSignUpProps, string> = {
    [PilotUserSignUpProps.firstName]: firstNameDisplayString,
    [PilotUserSignUpProps.lastName]: lastNameDisplayString,
    [PilotUserSignUpProps.email]: emailPlaceholder,
    [PilotUserSignUpProps.phone]: phoneDisplayString,
    [PilotUserSignUpProps.school]: 'Your School Name',
    [PilotUserSignUpProps.position]: 'Your Position',
    [PilotUserSignUpProps.city]: 'Anytown',
    [PilotUserSignUpProps.state]: 'Anystate',
    [PilotUserSignUpProps.information]: 'Additional information about your school'
  }
  export const MatIconByUserProp: Partial<Record<PilotUserSignUpProps, MatIconEnum | ''>> = {
    [PilotUserSignUpProps.email]: MatIconEnum.mail,
    [PilotUserSignUpProps.phone]: MatIconEnum.smartphone
  }
  export const UserCreateUpdateFormPrefix: Partial<Record<PilotUserSignUpProps, string>> = {
    [PilotUserSignUpProps.phone]: '+1'
  }
}
export class PilotUserSignUpModalViewModel {
  // FORM MODAL
  static readonly title = `Request to Join the OWL Early Access Program!`
  static readonly subtext = ``
  static readonly subtextSchoolAvailability = ``
  static confirmBtnText = 'Send Request'
  static cancelBtnText = 'Cancel'
  // SIGN UP SUCCESS CONFIRMATION MODAL
  static readonly signUpSuccessTitle = `Your request has been sent successfully!`
  static readonly signUpSuccessSubtext =
    'Someone from the OWL team will be in touch with you shortly for the next steps.'
  static readonly signUpSuccessSubtext2 = ''
  static readonly closeBtnText = 'Close'
}
